import { WorkerSelectionMode } from "@salon/types";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import type { OnlineBookingConfig } from "../hooks/use-online-booking-config";
import { SelectionModeToggle } from "./selection-mode-toggle";

export function WorkerSelectionModeToggle({
  saveField,
  saving,
}: {
  saveField: SaveField<OnlineBookingConfig>;
  saving: boolean;
}) {
  return (
    <SelectionModeToggle
      fieldName="workerSelectionMode"
      onValue={WorkerSelectionMode.ALL_SERVICES}
      offValue={WorkerSelectionMode.PRIMARY_SERVICE}
      i18nFieldKey="workerSelectionMode"
      saveField={saveField}
      saving={saving}
    />
  );
}
